import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'
import echarts from 'echarts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'
import '@/utils/dialogdrag.js';




import '@/icons' // icon
import '@/permission' // permission control



// 引入正则
import $regExp from "@/utils/regExp"
Vue.prototype.$regExp = $regExp;

// 引入mallConst全局常量
import $mallConst from "@/utils/mallConst"
Vue.prototype.$mallConst = $mallConst;

// 引入 mallFun 函数方法
import $mallFun from "@/utils/mallFun"
Vue.prototype.$mallFun = $mallFun;

// 兄弟组件通信
Vue.prototype.$EventBus = new Vue()

//通用下载
Vue.prototype.$saveFile = function (data) {
  var binaryData = [];
  binaryData.push(data.data);
  var blob = new Blob(binaryData);
  if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, data.name);
  } else {
      const link = document.createElement("a");
      const body = document.querySelector("body");
      link.href = window.URL.createObjectURL(blob);
      link.download = data.name;
      link.style.display = "none";
      body.appendChild(link);
      link.click();
      body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
  }
}

//通用下载2
Vue.prototype.$downLoadFile = function (res,fileName) {
  if (typeof window.chrome !== "undefined") {
    // Chrome version
    console.log(res);
    const link = document.createElement("a");
    const body = document.querySelector("body");
    link.href = window.URL.createObjectURL(res);
    link.download = fileName;
    body.appendChild(link);
    link.click();
    URL.revokeObjectURL(link.href); // 释放URL 对象
    body.removeChild(link); // 释放标签
  } else if (typeof window.navigator.msSaveBlob !== "undefined") {
    // IE version
    var blob = new Blob([res], {
      type: "application/force-download",
    });
    window.navigator.msSaveBlob(blob, res.fileNames);
  } else {
    // Firefox version
    var file = new File([res], res.fileNames, {
      type: "application/force-download",
    });
    window.open(URL.createObjectURL(file));
  }
}


import fileDownload from "js-file-download";

Vue.prototype.$downLoadFileTwo = function (res,fileName) {
  fileDownload(res, fileName);
}

Vue.use(ElementUI, { locale })
Vue.use(VCharts)
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

//全局修改element默认配置
ElementUI.TableColumn.props.showOverflowTooltip ={type:Boolean, default: true}
Vue.use(ElementUI)



// WEBPACK FOOTER //
// ./src/main.js